import React, { useContext, useEffect, useState } from "react";
import Images from "../../utils/images.js";
import { Link, NavLink } from "react-router-dom";
import CommonContext from "../../hooks/CommonContext.jsx";
import toast from "react-hot-toast";
import axiosInstance from "../../services/api/axiosInstance.js";
import Cookie from "js-cookie"

const SubscriptionExpiredPageNav = () => {

    const { gettingResponse, profilePicture, setProfilePicture, professionalProfileDropdown } = useContext(CommonContext);
    const [userNavbarinfo, setUserNavinfo] = useState([]);

    useEffect(() => {
        const getUserDetails = async () => {
            try {
                const res = await axiosInstance.get("/user_dashboard_details")

                if (res.data.error_code === 0) {
                    setProfilePicture(`${process.env.REACT_APP_SECOND_CAREERS_CDN}${res.data.data.user_details[0].profile_image}`);
                    setUserNavinfo([res.data.data]);
                }
                else {
                    toast.error(res.data.message);
                }
            } catch (err) {
                console.log(err)
            }
        };
        getUserDetails();
    }, []);

    const doLogout = () => {
        Cookie.remove("pToken")
    };

    return (
        <div className="navbar-height placeholder-glow">
            <nav className="navbar navbar-light bg-white fixed-top navbar-expand-md shadow-sm p-2 justify-content-center ">
                <div className="container-fluid">
                    <Link to="/professional/home" className="navbar-brand d-flex col-3" replace={true}>
                        <img src={Images.logo} alt="No Logo" className="img-fluid logo" />
                    </Link>

                    <div
                        className="offcanvas-lg offcanvas-start"
                        tabIndex="-1"
                        id="offcanvasResponsive"
                        aria-labelledby="offcanvasResponsiveLabel"
                    >
                        <div className="offcanvas-header">
                            <Link to="/professional/home" className="navbar-brand d-flex col-5" replace={true}>
                                <img src={Images.logo} alt="logo" className="img-fluid logo" />
                            </Link>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="offcanvas"
                                data-bs-target="#offcanvasResponsive"
                                aria-label="Close"
                            ></button>
                        </div>

                    </div>

                    <div className="row col-9">
                        <ul className="col-12 d-inline-flex list-unstyled mb-0 justify-content-end align-items-center">
                            <li>
                                <div className="dropdown navbar-dropdown px-2 pe-4" id={professionalProfileDropdown}>
                                    {gettingResponse === false && userNavbarinfo.length === 0 ? (
                                        <label className=" w-100">
                                            <span className="placeholder w-100 rounded py-2 pt-3 px-5"></span>
                                        </label>
                                    ) : (
                                        <>
                                            <a
                                                className="nav-link dropdown-toggle "
                                                href="#"
                                                id="navbarScrollingDropdown"
                                                role="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                <img
                                                    src={profilePicture}
                                                    alt="mdo"
                                                    width="32"
                                                    height="32"
                                                    className="rounded-circle me-2"
                                                    data-testid="Profile"
                                                />
                                                <span className="d-none d-sm-inline pe-2">
                                                    {userNavbarinfo.length > 0
                                                        ? userNavbarinfo[0].user_details !== undefined
                                                            ? userNavbarinfo[0].user_details[0].first_name
                                                            : null
                                                        : ""}
                                                    &nbsp;
                                                    {userNavbarinfo.length > 0
                                                        ? userNavbarinfo[0].user_details !== undefined
                                                            ? userNavbarinfo[0].user_details[0].last_name
                                                            : null
                                                        : ""}
                                                </span>
                                            </a>
                                            <ul
                                                className="dropdown-menu dropdown-menu-end professional-dashboard-menu-dropdown"
                                                aria-labelledby="navbarScrollingDropdown"
                                                data-testid="ProfileCard"
                                            >
                                                <li id="ProfessionalContact2ndCareers">
                                                    <a href="https://forms.gle/dP4xqG1TfLZUBoyG6" target="_blank" className="dropdown-item header-dropdown">
                                                        Get Support
                                                    </a>
                                                </li>
                                                <li>
                                                    <hr className="dropdown-divider" />
                                                </li>

                                                <li id="professionalSignOut" onClick={doLogout}>
                                                    <NavLink
                                                        to="/"
                                                        className="dropdown-item header-dropdown"
                                                        data-testid="logout"
                                                    >
                                                        Sign out
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        </>
                                    )}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default SubscriptionExpiredPageNav;